import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import _Tooltip from '@material-ui/core/Tooltip';
import { TypographyProps } from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  CreationState,
  DeliverableState,
  ModificationRequestDeliverable,
  Request,
  RequestState,
} from '../../../graphql/generated/graphql';

type Props = TypographyProps & {
  creationState: CreationState | null;
  latestDeliverableModificationRequest:
    | (Pick<Request, 'state'> & {
        deliverables: Array<Pick<ModificationRequestDeliverable, 'id'>>;
      })
    | null;
  className?: string;
};

const CreationStateMessage = ({
  creationState,
  latestDeliverableModificationRequest,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  let state = '';

  let helpIcon = null;

  if (
    latestDeliverableModificationRequest &&
    latestDeliverableModificationRequest.state === RequestState.GivenFeedback
  ) {
    state = RequestState.GivenFeedback;
  } else if (creationState === CreationState.ModificationRequested) {
    if (latestDeliverableModificationRequest && latestDeliverableModificationRequest.deliverables.length > 0) {
      state = 'waiting_review';
      helpIcon = (
        <Tooltip title={<FormattedMessage id={`creation_state.${state}.help`} />}>
          <HelpOutlineIcon fontSize="small" color="action" />
        </Tooltip>
      );
    } else {
      state = DeliverableState.ModificationRequested;
    }
  } else {
    state = creationState ? creationState : 'null';
  }

  return (
    <Root className={className}>
      {/* ここのやつが表示される */}
      <FormattedMessage id={`creation_state.${state}`} />
      {helpIcon}
    </Root>
  );
};

const Root = styled(Typography)({
  fontSize: '0.8125rem',
  fontWeight: 500,
});
const Tooltip = styled(_Tooltip)({
  marginLeft: 5,
});

export default CreationStateMessage;
